import * as _ from "lodash";
import * as log from "loglevel";
import * as React from "react";

import { observable } from "mobx";
import { inject, observer, Provider } from "mobx-react";
import { Link } from "react-router-dom";
import { AppStore } from "../../stores/app-store";
import { App } from "../../stores/models/app";
import { LoadingSpinner } from "../common/loading-spinner";
import { AppEditor } from "./app-editor";

interface IAppListProps{
	appStore?: AppStore;
}

interface IAppListState{
	selectedApp?: App;
	showEditor?: boolean;
	errorMessage?: string;
}

@inject("appStore") @observer
export class AppList extends React.Component<IAppListProps, IAppListState>
{
	constructor(props, state){
		super(props, state);

		this.state = {};
		this.handleNewApp = this.handleNewApp.bind(this);
		this.handleAppSelected = this.handleAppSelected.bind(this);
		this.handleCloseEditor = this.handleCloseEditor.bind(this);
	}

	async componentWillMount(){
		try {
			await this.props.appStore.loadApps();
			this.setState({"errorMessage": null});
		} catch (err) {
			log.error(err);
			this.setState({"errorMessage": err.message});
		}
	}


	async handleNewApp(){
		let app = new App();
		this.setState({"selectedApp": app, "showEditor": true});
	}

	async handleAppSelected(app: App){
		this.setState({"selectedApp": app, "showEditor": true});
	}

	handleCloseEditor(){
		this.setState({"selectedApp": null, "showEditor": false});
	}

	render(){
		let appStore: AppStore = this.props.appStore;
		let apps = appStore.apps.slice();

		return (
			<div  style={{"marginTop": "25px", "marginLeft": "150px", "marginRight": "150px"}}>
				<span className="list-header">Apps</span>
				<button className="circular ui icon button jibunu-blue" data-tooltip="Add Application" data-position="bottom center" onClick={this.handleNewApp}>
					<i className="icon plus" />
				</button>
				<div className="ui huge relaxed divided list">
					{apps.map((app: App) => {
						return(
								<a className="item" style={{"fontWeight": this.state.selectedApp && app.id == this.state.selectedApp.id ? "bold" : "normal"}} key={app.id} onClick={() => this.handleAppSelected(app)}>
									{app.name}
								</a>
							);
						})}
				</div>
				<AppEditor app={this.state.selectedApp} show={this.state.showEditor} onClose={this.handleCloseEditor} />
				{appStore.loading && <LoadingSpinner text={"Loading Applications"} />}
				{this.state.errorMessage &&
					<div className="ui red icon message">
						<i className="warning sign icon"></i>
						{this.state.errorMessage}
					</div>
				}
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./src/views/apps/app-list.tsx